export const skills = [
  "Semantic & accessible HTML",
  "Error handling",
  "Git",
  "Responsive Web Design",
  "React",
  "Next",
  "TailwindCSS",
  "Github Pull Request & Review",
  "JavaScript: ES6+",
  "TypeScript",
  "React Hooks",
  "NPM",
  "Working with API (fetch, axios)",
  "Redux (toolkit)",
  "Immutability",
  "Promises, Async/Await",
  "Redux-Saga",
  "Debugging",
  "React Router",
  "Scrum",
  "CSS",
  "Teamwork",
  "CSS BEM Convention",
];

export const nextSkills = [
  "Unit testing",
  "Node.js",
  "Vue.js",
];
